module.exports = __webpack_public_path__ + "static/media/project_white.24358f46.svg";